import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import * as LoginUtils from 'LoginUI/lib/LoginUtils';
import LoginLoading from '../LoginLoading';
import ErrorMessage from '../alerts/ErrorMessage';
import GoogleLoginButton from './GoogleLoginButton';
import ReturnLink from '../ReturnLink';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const STATE = {
  CONFIRMING_LOGIN: 0,
  CONFIRMATION_FAILED: 1
};
class GoogleLoginConfirmation extends Component {
  constructor(props) {
    super(props);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id_token' does not exist on type '{}'.
    const {
      id_token: token,
      state
    } = LoginUtils.parseParams(window.location.href);
    let parsedFragmentState;
    try {
      parsedFragmentState = JSON.parse(state);
    } catch (ex) {
      console.error(`Unable to parse state from Google ${state}`);
      parsedFragmentState = {};
    }
    const validUrl = token && parsedFragmentState;
    this.state = {
      error: validUrl ? '' : 'MISSING_FRAGMENTS',
      renderState: !validUrl ? STATE.CONFIRMATION_FAILED : STATE.CONFIRMING_LOGIN,
      successRedirectUrl: '',
      parsedFragmentState,
      token
    };
    this.triggerFailure = this.triggerFailure.bind(this);
    this.renderStates = this.renderStates.bind(this);
    this.renderConfirmationFailed = this.renderConfirmationFailed.bind(this);
    this.__renderStatesCached = this.renderStates();
  }
  componentDidMount() {
    document.title = I18n.text('login.googleLogin.pageTitle');
    const {
      renderState,
      token,
      parsedFragmentState
    } = this.state;
    const {
      onLoginSubmit
    } = this.props;
    if (renderState === STATE.CONFIRMING_LOGIN) {
      onLoginSubmit(token, parsedFragmentState, this.triggerFailure);
    }
  }
  triggerFailure(error) {
    this.setState({
      renderState: STATE.CONFIRMATION_FAILED,
      error
    });
  }
  renderStates() {
    return {
      [STATE.CONFIRMING_LOGIN]: this.renderConfirmingLogin,
      [STATE.CONFIRMATION_FAILED]: this.renderConfirmationFailed
    };
  }
  renderConfirmingLogin() {
    return /*#__PURE__*/_jsxs(Text, {
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(LoginLoading, {
        message: "google"
      }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "login.googleLogin.confirming"
      })]
    });
  }

  // FIX google button here
  renderConfirmationFailed() {
    const i18nPrefix = 'login.googleLogin.failed';
    const {
      error,
      parsedFragmentState
    } = this.state;
    return /*#__PURE__*/_jsxs(Text, {
      textAlign: "center",
      children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("h1", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${i18nPrefix}.header`
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "400",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${i18nPrefix}.instructions`
        })
      }), /*#__PURE__*/_jsx(ErrorMessage, {
        error: error
      }), /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "400",
        as: "div",
        children: /*#__PURE__*/_jsx(GoogleLoginButton, {
          onClick: () => this.props.onGoogleLoginClick(parsedFragmentState, this.triggerFailure)
        })
      }), /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `${i18nPrefix}.navigate`,
        options: {
          link: /*#__PURE__*/_jsx(ReturnLink, {})
        }
      })]
    });
  }
  render() {
    const {
      renderState
    } = this.state;
    const renderFunction = this.__renderStatesCached[renderState];
    if (renderFunction) {
      return renderFunction();
    } else {
      console.error(`Unknown landing state ${renderState}. Cannot render.`);
      return null;
    }
  }
}
GoogleLoginConfirmation.propTypes = {
  onGoogleLoginClick: PropTypes.func.isRequired,
  onLoginSubmit: PropTypes.func.isRequired
};
export default GoogleLoginConfirmation;